module.exports = __webpack_public_path__ + "img/116.2.a0343262.png";